<div class="position-relative" (clickOutside)="hideContent()">
  <a
    type="button"
    class="account-trigger d-flex justify-content-center p-2 pt-0 pe-0 position-relative"
    (click)="toggleContent()"
    data-cy="account-button"
  >
    <span class="rb-ic rb-ic-my-brand-frame fs-5xl hover-effect"></span>
  </a>

  <div
    *ngIf="isContentVisible"
    class="account-panel z-1 rounded-2 position-absolute end-0 border shadow-lg"
  >
    <div>
      <div class="account-header m-2 d-flex align-items-center gap-2 rounded-2 p-2">
        <span class="rb-ic rb-ic-my-brand-frame fs-3xl"></span>
        <span class="fs-xs text-nowrap" data-cy="account-name">{{
          account()?.idTokenClaims?.['email']
        }}</span>
      </div>

      <div class="account-divider d-flex flex-column pb-2 m-2 gap-2">
        <div class="account-section-label fs-2xs text-uppercase">Appearance</div>
        <div class="account-theme-wrap rounded-2 p-2">
          <rb-button-group
            class="w-100"
            [options]="themeOptions"
            [selectedValue]="selectedTheme()"
            (selectionValueChange)="onThemeChange($event)"
            name="button-sizes"
            size="small"
          ></rb-button-group>
        </div>
        <div
          class="account-action d-flex gap-2 align-items-center w-100 p-2 rounded-2 ho-menu-item"
          (click)="logout()"
          data-cy="account-logout"
        >
          <span class="rb-ic rb-ic-logout"></span>
          <span>Logout</span>
        </div>
      </div>
      <div
        class="account-footer fs-2xs p-4 rounded-bottom rounded-2 d-flex flex-column align-items-center flex-nowrap gap-1"
      >
        <span class="text-nowrap">© Robert Bosch GmbH 2026, all rights reserved</span>
        <div class="d-flex gap-2">
          <a class="account-link text-nowrap" href="assets/corporate-information.html"
            >Corporate information</a
          >
          <a class="account-link text-nowrap" href="assets/legal-notice.html">Legal notice</a>
        </div>
        <a class="account-link text-nowrap" href="assets/data-protection-notice.html"
          >Data protection notice</a
        >
      </div>
    </div>
  </div>
</div>
